import React from "react";
import AppContent from "../components/Content";
import AppFooter from "../components/Footer";
import styled from "styled-components";
import { supportDeviceSize } from "../components/styles";
import AppHeader from "components/Header";
import { HeaderProvider } from "../contexts/HeaderContext";
import { FooterProvider } from "../contexts/FooterContext";
import { SEO } from "../components/SEO";

const DefaultLayout = () => {
  return (
    <HeaderProvider>
      <FooterProvider>
        <Root>
          <SEO 
            title="PUZL 퍼즐코퍼레이션 | 성과중심 퍼포먼스·UGC·콘텐츠 풀퍼널 마케팅"
            description="퍼즐코퍼레이션은 브랜드의 성장을 위한 최적의 풀퍼널 마케팅 전략을 제안합니다. 퍼포먼스 광고, UGC 콘텐츠 제작, 미디어 플래닝 등 맞춤형 전략으로 지속가능한 성과를 달성하세요."
            keywords="퍼즐코퍼레이션, PUZL, 풀퍼널마케팅, 디지털마케팅, IT솔루션, 그로스마케팅, 퍼포먼스마케팅"
            ogImage="/images/og-image2.png"
          />
          <AppHeader />
          <AppContent />
          <AppFooter />
        </Root>
      </FooterProvider>
    </HeaderProvider>
  );
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: ${window.location.pathname === '/contact/result' ? '90vh' : '100vh'};
  background-color: transparent;
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;

  @media all and (max-width: ${supportDeviceSize}px) {
    width: 100%;
  }
`;

export default DefaultLayout;
